import React from 'react';
import { ParkingWizardStep } from 'Stores/ParkingWizardStore';

interface ParkingProgressBarProps {
	steps: { key: ParkingWizardStep; label: string }[];
	currentStep: ParkingWizardStep;
}

export function ParkingProgressBar({ steps, currentStep }: ParkingProgressBarProps) {
	const currentIndex = steps.findIndex(s => s.key === currentStep);

	return (
		<div className="parking-wizard__progress-bar">
			{steps.map((step, index) => (
				<div
					key={step.key}
					className={`parking-wizard__progress-step ${
						index < currentIndex ? 'completed' : ''
					} ${index === currentIndex ? 'active' : ''}`}
				>
					<div className="parking-wizard__progress-circle">{index < currentIndex ? '\u2713' : index + 1}</div>
					<span className="parking-wizard__progress-label">{step.label}</span>
				</div>
			))}
		</div>
	);
}
